export class PvhOrderAcceptanceRequest {
  id: number;
  poNumber: string;
  plmStyle: string;
  itemNo: string;
  buyerName: string;
  deliveryDate: string;
  poLine: string;
  transMode: string;
  deliveryAddress: string;

}

export class PvhApproveRequest {
  coReqDetails: {
    id: number;
    poNumber: string;
    plmStyle: string;
    itemNo: string;
    buyerName: string;
    deliveryDate: string;
    poLine: string;
    transMode: string;
    deliveryAddress: string;
  }[]

}